<template>
  <div />
</template>

<script>
import * as echarts from "echarts";

export default {
  props: {
    chartDataX: {
      type: Array,
    },
    chartDataY: {
      type: Array,
    },
    SecondchartDataY: {
      type: Array,
    },
    showDate: {
      type: Boolean,
      default: false
    },

  },
  data() {
    return {
      chart: null,
    };
  },
  mounted() {
    this.$nextTick(() => {
      //解决数据还没初始化就初始化表格的bug
      setTimeout(() => {
        this.initChart();
      }, 200);
    });
    window.addEventListener("resize", this.windowResize);
  },
  methods: {
    windowResize() {
      //销毁图表重新画;
      setTimeout(() => {
        this.initChart();
      }, 100);
    },
    initChart() {
      if (this.$el.offsetHeight === 0) {
        return;
      }
      echarts.dispose(this.$el);
      this.chart = echarts.init(this.$el);
      this.setOptions();
    },
    setOptions() {
      if (this.chart === null) {
        return;
      }
      const colors = ["#5470C6", "#00d1ed", "#EE6666"];
      this.chart.setOption({
        color: colors,
        tooltip: {
          trigger: "axis",
        },
        legend: {
          data: ["公里", "运行次数"],
          textStyle: { color: "#7F8488" },
        },
        xAxis: [
          {
            type: "category",
            axisTick: {
              alignWithLabel: true,
            },
            axisLine: {
              lineStyle: { color: "#7F8488" },
            },
            data: this.chartDataX,
            axisLabel: {
              color: '#7F8488',
              formatter: (params) => {
                let time = new Date(params);
                const y = time.getFullYear();
                const m = time.getMonth() + 1;
                const d = time.getDate();
                const h = time.getHours();
                const mm = time.getMinutes();
                if (this.showDate) {
                  return (m < 10 ? '0' + m : m) + '-' + (d < 10 ? '0' + d : d);
                } else {
                  return (h < 10 ? '0' + h : h) + ':' + (mm < 10 ? '0' + mm : mm);
                }
              }
            }
          },
        ],
        yAxis: [
          {
            type: "value",
            name: "运行次数",
            position: "right",
            alignTicks: true,

            axisLine: {
              show: true,
              lineStyle: {
                color: colors[1],
              },
            },
            splitLine: {
              show: true,
              lineStyle: { color: ["#d6d6d65e"], width: 1, type: "dashed" },
            },
            axisLabel: {
              formatter: "{value} ",
            },
          },
          {
            type: "value",
            name: "公里",
            position: "left",
            alignTicks: true,
            axisLine: {
              show: true,
              lineStyle: {
                color: colors[0],
              },
            },
            splitLine: {
              show: true,
              lineStyle: { color: ["#244447"], width: 1, type: "dashed" },
            },
            axisLabel: {
              formatter: "{value}",
            },
          },
        ],
        grid: {
          top: "30px",
          left: "40px",
          right: "40px",
          bottom: "5px",
          containLabel: true
        },
        series: [
          {
            name: "公里",
            type: "bar",
            yAxisIndex: 1,
            barMaxWidth: 20,
            data: this.chartDataY,
          },
          {
            name: "运行次数",
            type: "line",
            data: this.SecondchartDataY,
          },
        ],
      });
    },
  },
  watch: {
    chartDataX: {
      deep: true,
      handler: function () {
        this.setOptions();
      },
    },
    chartDataY: {
      deep: true,
      handler: function () {
        this.setOptions();
      },
    },
    SecondchartDataY: {
      deep: true,
      handler: function () {
        this.setOptions();
      },
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/barEchart.vue